import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-bulgari-background',
  templateUrl: './bulgari-background.component.html',
  styleUrl: './bulgari-background.component.scss',
  standalone: false
})
export class BulgariBackgroundComponent {

  @Input('style') style?: any;

}
